// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tickets-stack {
  list-style: none;
  margin: 1.5rem 0;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  overflow: hidden;
  background: #fff;
}

.tickets-item {
  position: relative;
  border-bottom: 1px solid #f1f5f9;
}

.tickets-item:last-child {
  border-bottom: none;
}

.tickets-item::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: transparent;
  transition: background-color 0.2s ease;
}

.tickets-item:hover::before {
  background: #f97316;
}

.tickets-item__content {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 1.1rem 1.5rem;
}

.tickets-item__info {
  flex: 1 1;
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
}

.tickets-item__id {
  font-weight: 600;
  color: #94a3b8;
}

.tickets-item__subject {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
}

.tickets-item__meta {
  font-size: 1rem;
  color: #475569;
}

.tickets-item__status {
  display: inline-flex;
  gap: 0.5rem;
}

.badge {
  padding: 0.4rem 1rem;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 600;
  background: #eef2ff;
  color: #3730a3;
}

.badge--priority {
  background: #fff7ed;
  color: #c2410c;
}

.tickets-empty {
  padding: 1.5rem;
  text-align: center;
  color: #94a3b8;
}

.tickets-status {
  margin: 1rem 0;
  color: #475569;
}

.tickets-status--error {
  color: #dc2626;
}`, "",{"version":3,"sources":["webpack://./src/composants/Ticket/TicketTab/TicketTab.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".tickets-stack {\n  list-style: none;\n  margin: 1.5rem 0;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  background: #fff;\n}\n\n.tickets-item {\n  position: relative;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.tickets-item:last-child {\n  border-bottom: none;\n}\n\n.tickets-item::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: transparent;\n  transition: background-color 0.2s ease;\n}\n\n.tickets-item:hover::before {\n  background: #f97316;\n}\n\n.tickets-item__content {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  padding: 1.1rem 1.5rem;\n}\n\n.tickets-item__info {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 110px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 1rem;\n}\n\n.tickets-item__id {\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.tickets-item__subject {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.tickets-item__meta {\n  font-size: 1rem;\n  color: #475569;\n}\n\n.tickets-item__status {\n  display: inline-flex;\n  gap: 0.5rem;\n}\n\n.badge {\n  padding: 0.4rem 1rem;\n  border-radius: 999px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  background: #eef2ff;\n  color: #3730a3;\n}\n\n.badge--priority {\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.tickets-empty {\n  padding: 1.5rem;\n  text-align: center;\n  color: #94a3b8;\n}\n\n.tickets-status {\n  margin: 1rem 0;\n  color: #475569;\n}\n\n.tickets-status--error {\n  color: #dc2626;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
